import createBrowserHistory from 'history/createBrowserHistory';

const router = createBrowserHistory();

router.listen((location) => {
    const _paq = window._paq || [];
    const { pathname, search, hash } = location;
    const fullUrl = `${pathname}${search}${hash}`;

    _paq.push(['setCustomUrl', fullUrl]);
    _paq.push(['trackPageView']);
});

export default router;



// WEBPACK FOOTER //
// ./src/config/history.js